class HeaderSearch extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['input']
  }

  static get matches () {
    return {
      input: '[data-header-search-el="input"]',
      close: '[data-header-search-el="close"]',
      trigger: '[data-header-search-external-el="trigger"]',
      klevu: '.klevu-fluid',
      iconSearch: '.hd-Search_Icon-search',
      searchRoot: 'header-search',
    }
  }

  static get bodyListeners () {
    if (!HeaderSearch._bodyListeners) {
      HeaderSearch._bodyListeners = new window.BAO.Listeners()
    }

    return HeaderSearch._bodyListeners
  }

  static get classes () {
    return {
      searchFocus: 'util-SearchFocus',
      searchHasValue: 'util-SearchHasValue',
    }
  }

  get config () {
    return {
      matches: this.constructor.matches,
      classes: this.constructor.classes,
    }
  }

  setupListeners () {
    super.setupListeners()

    this.onInputFocus = this.onInputFocus.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
    this.onKeyDown = this.onKeyDown.bind(this)
    this.onTriggerClick = this.onTriggerClick.bind(this)
    this.onCloseClick = this.onCloseClick.bind(this)

    if (!this.els?.input?.exists) return

    this.listeners.add(this.els.input.element, 'focus', this.onInputFocus)
    this.listeners.add(this.els.input.element, 'input', this.onInputChange)
    this.listeners.add(document, 'keydown', this.onKeyDown)
    this.syncSearchValueClass()
    this.toggleAnimatedSearchText()
    this.toggleCloseButton()

    if (this.els?.close?.exists) {
      this.els.close.elements.forEach(closeEl => {
        this.listeners.add(closeEl, 'click', this.onCloseClick)
      })
    }

    if (this.externalEls?.trigger?.exists) {
      this.externalEls.trigger.elements.forEach(triggerEl => {
        this.listeners.add(triggerEl, 'click', this.onTriggerClick)
      })
    }

    if (!HeaderSearch._bodyClickAttached) {
      HeaderSearch._bodyClickAttached = true

      HeaderSearch.bodyListeners.add(
        document.body,
        'click',
        HeaderSearch.handleBodyClick,
      )
    }
  }

  onInputFocus () {
    document.body.classList.add(this.config.classes.searchFocus)
    this.toggleCloseButton()
  }

  onInputChange () {
    this.syncSearchValueClass()
    this.toggleAnimatedSearchText()
    this.toggleCloseButton()
  }

  syncSearchValueClass () {
    const hasValue = this.els.input.element.value.trim().length > 0

    document.body.classList.toggle(
      this.config.classes.searchHasValue,
      hasValue,
    )
  }

  onKeyDown (e) {
    if (e.key !== 'Escape') return

    const isActive =
      document.body.classList.contains(this.config.classes.searchFocus) ||
      this.els.input.element.value.trim().length > 0

    if (isActive == false) return

    this.closeSearch()
  }

  onTriggerClick () {
    document.body.classList.add(this.config.classes.searchFocus)
    this.els.input.element.focus()
    this.toggleCloseButton()
  }

  onCloseClick (e) {
    e.preventDefault()
    this.closeSearch()
  }

  closeSearch () {
    if (this.els?.input?.exists) {
      const input = this.els.input.element

      if (input.value !== '') {
        input.value = ''
        input.dispatchEvent(
          new InputEvent('input', {
            bubbles: true,
            inputType: 'deleteContentBackward',
          }),
        )
      }

      input.blur()
    }

    document.body.classList.remove(this.config.classes.searchFocus)
    this.syncSearchValueClass()
    this.toggleAnimatedSearchText()
    this.toggleCloseButton()
  }

  toggleAnimatedSearchText () {
    if (!this.els?.animation?.exists) return

    const hasValue = this.els.input.element.value.trim().length > 0

    this.els.animation.element.style.display = hasValue ? 'none' : ''
  }

  toggleCloseButton () {
    if (!this.els?.close?.exists) return

    const isActive =
      document.body.classList.contains(this.config.classes.searchFocus) ||
      this.els.input.element.value.trim().length > 0

    this.els.close.element.setAttribute('aria-hidden', isActive ? 'false' : 'true')
  }

  static handleBodyClick (e) {
    if (HeaderSearch.isSearchInteraction(e.target)) return

    document.querySelectorAll('header-search').forEach(el => {
      if (typeof el.closeSearch === 'function') {
        el.closeSearch()
      }
    })
  }

  static isSearchInteraction (target) {
    return Object.values(HeaderSearch.matches).some(
      selector => target.closest(selector) !== null,
    )
  }
}

if (!customElements.get('header-search')) {
  customElements.define('header-search', HeaderSearch)
}
